/* GLOW by LIZNA v4.0 — Vanilla JavaScript */
(function() {
  'use strict';

  /* Mobile nav toggle */
  const navToggle = document.querySelector('.nav-toggle');
  const navOverlay = document.querySelector('.nav-overlay');
  const navMenu = document.querySelector('.nav-menu');
  const navLinks = document.querySelectorAll('.nav-link');

  const navClose = document.querySelector('.nav-close');

  if (navToggle) {
    navToggle.addEventListener('click', () => {
      navMenu?.classList.add('is-open');
      navOverlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      navToggle.setAttribute('aria-expanded', 'true');
    });
  }

  navClose?.addEventListener('click', closeNav);
  navOverlay?.addEventListener('click', closeNav);
  navLinks.forEach(link => link.addEventListener('click', closeNav));

  function closeNav() {
    navMenu?.classList.remove('is-open');
    navOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
    navToggle?.setAttribute('aria-expanded', 'false');
  }

  /* Intersection Observer for reveals */
  const reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );

    reveals.forEach(el => observer.observe(el));

    setTimeout(() => {
      reveals.forEach(el => {
        if (!el.classList.contains('is-visible')) {
          el.classList.add('is-visible');
        }
      });
    }, 6000);
  }

  /* Newsletter form */
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]');
      if (email?.value) {
        /* PENDIENTE_CONFIRMAR: conectar a ESP (Klaviyo/Mailchimp) antes de publicar */
        email.value = '';
        showToast('¡Gracias! Bienvenido al universo GLOW.');
      }
    });
  });

  function showToast(msg) {
    const toast = document.createElement('div');
    toast.className = 'toast show';
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }

  /* CTA flotante: aparece al pasar el hero, se oculta en el footer */
  const ctaFlotante = document.getElementById('cta-flotante');
  const heroSection = document.getElementById('hero');
  const footerSection = document.querySelector('.footer-glow');

  if (ctaFlotante && heroSection) {
    let ticking = false;

    function updateCta() {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const footerTop = footerSection ? footerSection.getBoundingClientRect().top : Infinity;
      const windowH = window.innerHeight;

      const pasadoHero = heroBottom < 0;
      const enFooter = footerTop < windowH * 0.85;

      if (pasadoHero && !enFooter) {
        ctaFlotante.classList.add('is-visible');
      } else {
        ctaFlotante.classList.remove('is-visible');
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateCta);
        ticking = true;
      }
    }, { passive: true });
  }
})();

/* GLOW V4 · PATCH VISUAL 02 · Carousel buttons + hero video rotation smooth */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Carousel productos
    const carousel = document.getElementById('render-carousel');
    const prev = document.getElementById('render-prev');
    const next = document.getElementById('render-next');

    if (carousel && prev && next) {
      prev.addEventListener('click', function () {
        carousel.scrollBy({
          left: -Math.max(360, Math.floor(carousel.clientWidth * 0.82)),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', function () {
        carousel.scrollBy({
          left: Math.max(360, Math.floor(carousel.clientWidth * 0.82)),
          behavior: 'smooth'
        });
      });
    }

  });
})();






